import $ from 'jquery';

const MODAL_OPEN_CLASS = 'vx_modalIsOpen';

export function showActionableErrorModal(errMsg) {
	$('#actionable-error-model').addClass(MODAL_OPEN_CLASS);
	document.getElementById('actionable-error-msg').innerHTML = errMsg;
}

export function hideActionableErroModal() {
	$('#actionable-error-model').removeClass(MODAL_OPEN_CLASS);
}

export function showUnactionableErrorModal() {
	$('#unactionable-error-modal').addClass(MODAL_OPEN_CLASS);
}

export function hideUnactionableErrorModal() {
	$('#unactionable-error-modal').removeClass(MODAL_OPEN_CLASS);
}

export function showLeaveModal() {
	$('#leave-modal').addClass(MODAL_OPEN_CLASS);
}

export function hideLeaveModal() {
	$('#leave-modal').removeClass(MODAL_OPEN_CLASS);
}



// WEBPACK FOOTER //
// ./buttons/utils/modalUtils.js